import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        activeMenuKey: 1
    },
    mutations: {
        SET_ACTIVE_MENU_KEY(state, payload) {
            state.activeMenuKey = payload;
        },
    },
    actions: {
        updateActiveMenuKey(context, payload) {
            context.commit('SET_ACTIVE_MENU_KEY', payload);
        },
    },
    modules: {}
})
